import { VariantClassesProps } from '../../utils'
import { InputColorType, InputSize, InputVariant } from './Input.types'

// Main style getters
/** Styles for primary input variant */
const getPrimaryClasses = (color: InputColorType): string => {
    const colorClasses: VariantClassesProps = {
        primary:
            'bg-background-base border-none outline-none text-color-title disabled:bg-background-disabled/20 disabled:shadow-none',
        secondary:
            'bg-slate-800 border-slate-700 text-[hsl(var(--text-muted))] disabled:bg-background-disabled disabled:border-background-disabled/20',
        success: 'shadow-success border-none',
        warning: 'shadow-warning border-none',
    }
    return colorClasses[color] || colorClasses.primary // Default color: primary
}

/** Base styles for the input */
export const getBaseClasses = (): string => {
    return 'w-full shadow-modal font-sans placeholder:text-dropdown-hover'
}

export const getNoLabelClasses = (size: InputSize, label?: string): string => {
    if (!label) {
        if (size === 'lg') {
            return 'gap-5'
        } else if (size === 'md') {
            return 'gap-2.5'
        } else if (size === 'sm') {
            return 'gap-2'
        }
    }
    return ''
}

/** Size styles for the input */
export const getSizeClasses = (inputSize: InputSize): string => {
    const sizeClasses: VariantClassesProps = {
        sm: 'p-3 text-2xs font-bold placeholder:font-normal placeholder:text-dropdown-hover',
        base: 'px-4 py-3 text-2xs font-bold placeholder:font-normal placeholder:text-dropdown-hover',
        md: 'px-6 py-4 text-xs font-bold placeholder:font-normal placeholder:text-dropdown-hover',
        lg: 'px-8 py-5 text-xs font-bold placeholder:font-normal placeholder:text-dropdown-hover',
    }
    return sizeClasses[inputSize] || sizeClasses.md // Default size: md
}

/** Variant styles controller */
export const getVariantClasses = (
    variant: InputVariant,
    color: InputColorType
): string => {
    const variantClasses: VariantClassesProps = {
        primary: getPrimaryClasses(color),
    }

    return variantClasses[variant] || variantClasses.primary // Default variant: primary
}
